import { all, call, put, takeLatest } from 'redux-saga/effects';
import { browserHistory, updateDocumentTitle } from '../utils/browser-history';
import i18n from '../locale';
import Api from '../utils/api';
import {
  FETCH_INIT_DATA_REQUEST,
  FETCH_INIT_DATA_SUCCESS,
  FETCH_INIT_DATA_FAILURE,
  SET_USER_DATA
} from '../redux/action/types';

import { defaultInfoModalState } from '../redux/reducer/types';

function* fetchInitData(errorButton) {
  try {
    const baseInitData = yield call(Api.getInitData);
    const {
      data: { auth_url: baseApiUrl, website_url: websiteUrl }
    } = baseInitData;

    localStorage.setItem('websiteUrl', websiteUrl);
    Api.setBaseUri(`${baseApiUrl}/api/v1`);

    // first of all handle prices data with id's
    const [
      nationalities,
      countries,
      twoFaDataDisabled,
      twoFaDataChecked,
      verifications,
      kycAllowedTypes,
      user,
      available2FAResp,
    ] = yield all([
      call(() => Api.getNationalities()),
      call(() => Api.getCountries()),
      call(() => Api.get2FAOptsDisabledInfo()),
      call(() => Api.get2FAOptsCheckedInfo()),
      call(() => Api.get2FAVerifications()),
      call(() => Api.getKycAllowedTypes()),
      call(() => Api.getUserData()),
      call(() => Api.getAvailable2FARequest()),
    ]);

    const kycSubtypes = yield all(
      kycAllowedTypes.data.map(type => call(() => Api.getKycSubtypes(type)))
    );

    const subtypes = kycSubtypes.reduce((acc, d) => {
      const reducedData = d.data.reduce(
        (accx, dx) => ({
          ...accx,
          [dx.code]: dx
        }),
        {}
      );
      return { ...acc, ...reducedData };
    }, {});

    yield put({
      type: SET_USER_DATA,
      data: user
    });

    yield put({
      type: FETCH_INIT_DATA_SUCCESS,
      data: {
        nationalities: nationalities.data,
        countries: countries.data,
        kyc: {
          ...{ allowedTypes: kycAllowedTypes.data },
          ...{ subtypes }
        },
        twoFaDataDisabled: twoFaDataDisabled.data,
        twoFaDataChecked: twoFaDataChecked.data,
        verifications: verifications.data,
        logo: baseInitData.data.client_logo,
        theme: baseInitData.data.style,
        backToAppUrl: baseInitData.data.back_to_app_url,
        u2fUrl: baseInitData.data.back_to_app_url,
        customFields: baseInitData.data.custom_columns,
        title: baseInitData.data.title,
        favicon: baseInitData.data.favicon,
        appType: baseInitData.data.app || 'web',
        modules: baseInitData.data.modules,
        available2FA: available2FAResp.data,
        nonEditableFields: baseInitData.data.nonEditable,
      }
    });

    // set initial document title after data from API are successfully retrieved
    const titleFromApi = baseInitData.data.title;
    updateDocumentTitle(titleFromApi, true);
    // set "change browser url" listener
    browserHistory.listen(() => updateDocumentTitle(titleFromApi));
  } catch (e) {
    console.log('INIT DATA ERROR:', e);
    const infoModalContent = defaultInfoModalState;
    if (e.status === 400 || e.status === 404) {
      infoModalContent.isOpen = true;
      infoModalContent.type = 'error';
      infoModalContent.message = i18n.t('components:modal.error.message');
      infoModalContent.callback.fnc = errorButton.callback;
      infoModalContent.callback.btnText = errorButton.text;
    }

    yield put({
      type: FETCH_INIT_DATA_FAILURE,
      data: {
        infoModal: {
          isOpen: true,
          type: 'error',
          ...infoModalContent
        }
      }
    });
  }
}

export default function* initDataSaga() {
  yield takeLatest(FETCH_INIT_DATA_REQUEST, data => fetchInitData(data.data));
}
